import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deactivateUserAccount } from 'store/account/enterprise';

export function useDeactivateUserAccount(): Operation<(userId: string) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.DEACTIVATE_USER_ACCOUNT);

	function handler(userId: string) {
		dispatch(deactivateUserAccount(userId));
	}

	return [{ loading, error }, handler];
}
